import { t } from '../../i18n.es.js';
import React from 'react';
import { styled } from '@teko/ui';
import { PromoItem } from '../PromoItem/PromoItem.es.js';

var PromoBlockStatus = /* @__PURE__ */ ((PromoBlockStatus2) => {
  PromoBlockStatus2["SELECTED"] = "selected";
  PromoBlockStatus2["ACTIVE"] = "active";
  PromoBlockStatus2["INACTIVE"] = "inactive";
  return PromoBlockStatus2;
})(PromoBlockStatus || {});
const Container = styled.div(({ hasBorderRadius, hasBorder, theme, blockBackground }) => `
    width: 100%;
    padding: 1rem 0 1rem 1rem;
    background-color: ${blockBackground ? blockBackground : "white"};
    display: flex;
    align-items: center;
    border-bottom: ${hasBorder ? `1px solid ${theme == null ? void 0 : theme.colors.border}` : "none"};
    border-radius: ${hasBorderRadius ? `8px` : "0"};
    margin-bottom: 12px;
  `);
const Left = styled.div(({ theme, showRight }) => `
    border-right: ${showRight ? `1px dashed ${theme == null ? void 0 : theme.colors.border}` : `unset`};
    padding-right: 1rem;
    flex: 1;
  `);
const Description = styled.p(({ theme }) => `
    margin: 0;
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 1rem;
    color: ${theme == null ? void 0 : theme.colors.gray130};
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    margin-bottom: 0.75rem;
  `);
const Button = styled.span(({ isActive, theme }) => `
    font-size: 0.8125rem;
    font-weight: 400;
    line-height: 1.25rem;
    color: ${isActive ? theme == null ? void 0 : theme.colors.link500 : theme == null ? void 0 : theme.colors.gray130};
    width: 6rem;
    text-align: center;
    padding: 0.5rem;

    &:hover {
      cursor: pointer;
    }
`);
const StyledPromoItem = styled(PromoItem)`
  &:not(:last-child) {
    margin-bottom: 0.75rem;
  }
`;
const PromoBlock = ({
  benefits,
  description,
  status,
  hasBorder,
  hasBorderRadius = false,
  blockBackground,
  customBtn,
  onClick,
  showRight = true
}) => {
  const statusMap = {
    ["selected" /* SELECTED */]: t("B\u1ECF ch\u1ECDn"),
    ["active" /* ACTIVE */]: t("\xC1p d\u1EE5ng"),
    ["inactive" /* INACTIVE */]: t("Mua th\xEAm")
  };
  return /* @__PURE__ */ React.createElement(Container, {
    hasBorder,
    hasBorderRadius,
    blockBackground
  }, /* @__PURE__ */ React.createElement(Left, {
    showRight
  }, description && /* @__PURE__ */ React.createElement(Description, null, description), benefits.map(({ type, text, imgSrc }, index) => /* @__PURE__ */ React.createElement(StyledPromoItem, {
    type,
    text,
    imgSrc,
    key: index
  }))), showRight && (customBtn || /* @__PURE__ */ React.createElement(Button, {
    isActive: status !== "inactive" /* INACTIVE */,
    onClick
  }, statusMap[status] || "")));
};

export { PromoBlock, PromoBlockStatus };
